<template>
  <div>
    <Sidebar :forceVisible="forceSidebarVisible" :refresh="refreshSidebar"></Sidebar>

    <div class="dashboard">
      <MessageBar :message="currentMessage" :isError="isErrorMessage"></MessageBar>

      <div class="main-panel">
        <Navbar></Navbar>

        <div class="content" v-on:click="closeSidebar">
          <div class="pane" v-bind:class="{visible: isPaneSelected('slide-builder')}">
            <h1>Slide Builder</h1>
            <SlideBuilder :refresh="refreshSlideList"></SlideBuilder>
          </div>

          <div class="pane" v-bind:class="{visible: isPaneSelected('subscribe')}">
            <h1>Screen Subscriptions</h1>
            <Subscribe></Subscribe>
          </div>

          <div class="pane" v-bind:class="{visible: isPaneSelected('device-management')}">
            <h1>Screen Management</h1>
            <DeviceManagement></DeviceManagement>
          </div>

          <div class="pane" v-bind:class="{visible: isPaneSelected('slideshows')}">
            <h1>Your Slideshows</h1>
            <SlideshowList :refresh="refreshSlideshowList"></SlideshowList>
          </div>

          <div class="pane" v-bind:class="{visible: isPaneSelected('menu-builder')}">
            <h1>Menu Builder</h1>
            <MenuBuilder :refresh="refreshMenuList"></MenuBuilder>
          </div>

          <div class="pane" v-bind:class="{visible: isPaneSelected('editor')}">
            <h1>Edit Slideshow Settings</h1>
            <SlideshowEditor :slideshow="currentSlideshow"></SlideshowEditor>
          </div>

          <div class="pane" v-bind:class="{visible: isPaneSelected('profile')}">
            <h1>Your Profile</h1>
            <EditProfile :user="PS.user"></EditProfile>
          </div>

          <div class="pane" v-bind:class="{visible: isPaneSelected('organization')}">
            <h1>Organization</h1>
            <Organization :refresh="refreshOrganization"></Organization>
          </div>

          <div class="pane" v-bind:class="{visible: isPaneSelected('users')}">
            <h1>Users</h1>
            <Users :refresh="refreshUsers"></Users>
          </div>

          <div class="pane" v-bind:class="{visible: isPaneSelected('tutorials')}">
            <h1>Tutorials</h1>
            <Tutorials></Tutorials>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '../styles/base.css'
import DeviceManagement from './DeviceManagement.vue'
import EditProfile from './EditProfile.vue'
import MenuBuilder from './MenuBuilder.vue'
import MessageBar from './MessageBar.vue'
import Navbar from './Navbar.vue'
import Organization from './Organization.vue'
import Sidebar from './Sidebar.vue'
import SlideBuilder from './SlideBuilder.vue'
import SlideshowEditor from './SlideshowEditor.vue'
import SlideshowList from './SlideshowList.vue'
import Subscribe from './Subscribe.vue'
import Tutorials from './Tutorials.vue'
import Users from './Users.vue'

export default {
  name: 'Dashboard',

  components: {
    DeviceManagement,
    EditProfile,
    MenuBuilder,
    MessageBar,
    Navbar,
    Organization,
    Sidebar,
    SlideBuilder,
    SlideshowEditor,
    SlideshowList,
    Subscribe,
    Tutorials,
    Users
  },

  data () {
    return {
      currentMessage: '',
      currentSlideshow: {},
      forceSidebarVisible: false,
      isErrorMessage: false,
      refreshMenuList: false,
      refreshOrganization: false,
      refreshSidebar: false,
      refreshSlideList: false,
      refreshSlideshowList: false,
      refreshUsers: false,
      selectedPane: 'slide-builder'
    }
  },

  methods: {
    closeSidebar: function () {
      if (this.forceSidebarVisible) {
        this.forceSidebarVisible = !this.forceSidebarVisible
      }
    },

    getUserData: function () {
      this.axios.get('api/user')
        .then((response) => {
          localStorage.setItem('user', JSON.stringify(response.data.user))
          PS.user = response.data.user
          this.refreshMenuList = true
          this.refreshSlideList = true
          this.refreshSlideshowList = true
          this.refreshSidebar = true
          this.setSelectedPane('slide-builder')
        }).catch((errors) => {
          localStorage.clear()
          this.$router.push('/login')
        })
    },

    isPaneSelected: function (pane) {
      return pane === this.selectedPane
    },

    setCurrentMessage: function (message, isError) {
      this.currentMessage = message
      this.isErrorMessage = isError
    },

    setCurrentSlideshow: function (slideshow) {
      this.currentSlideshow = slideshow
    },

    setSelectedPane: function (pane) {
      if (pane === 'slideshows') {
        this.refreshSlideshowList = true
      } else if (pane === 'menu-builder') {
        this.refreshMenuList = true
      } else if (pane === 'organization') {
        this.refreshOrganization = true
      } else if (pane === 'users') {
        this.refreshUsers = true
      } else if (pane === 'slide-builder') {
        this.refreshSlideList = true
      }

      this.selectedPane = pane

      this.$gtag.pageview('/' + this.selectedPane)
    }
  },

  mounted () {
    this.getUserData()
  }
}
</script>

<style scoped>
  .dashboard {
    background: var(--dashboard-bg);
    height: 100%;
    min-height: 100vh;
    overflow: auto;
  }

  .action-icon {
    height: 45px;
    padding: .5em;
    position: relative;
    top: 2px;
    transition: all 0.25s ease-out;
  }

  .action-icon:hover {
    transform: scale(1.25);
  }

  .collection {
    background: rgb(48, 48, 48);
    background-repeat: no-repeat;
    background-size: cover;
    border: none;
    border-radius: 6px 6px 0px 0px;
    height: 162px;
    width: 288px;
    transition: all 0.25s ease-out;
  }

  .collection-container {
    box-shadow: 0 1px 9px 1px rgba(39,39,39,.3);
    border-radius: 6px;
    display: inline-block;
    justify-content: space-around;
    margin: 1em;
    vertical-align: top;
    width: 288px;
  }

  .collection-title {
    color: var(--dashboard-text);
    display: inline-block;
    padding: .75em;
    text-align: left;
  }

  .collection-actions {
    color: var(--dashboard-text);
    float: right;
    position: relative;
    text-align: right;
  }

  .content {
    background: var(--dashboard-bg);
    padding: 1em 1em 0;
  }

  .main-panel {
    height: 100%;
    position: relative;
    transition: all .5s cubic-bezier(.685,.0473,.346,1);
  }

  @media only screen and (max-width: 991px) {
    .main-panel {
      width: 100%;
    }
  }

  .pane {
    color: var(--dashboard-text);
    display: none;
    height: 100%;
    width: 100%
  }

  .pane-separator {
    margin: 0;
  }

  h1 {
    margin: 0;
  }

  .visible {
    display: block;
  }
</style>
